var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./demographics-edit-birthday.j2"] = require( "./demographics-edit-birthday.j2" );
dependencies["./demographics-edit-gender.j2"] = require( "./demographics-edit-gender.j2" );
dependencies["./demographics-edit-student.j2"] = require( "./demographics-edit-student.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/demographics-edit.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"formFocus") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"focusValue") != "demographics") {
output += "\n\n<section class=\"c-profile__section js-account-demographics is-focused\">\n\n";
;
}
else {
output += "\n\n<section class=\"c-profile__section js-account-demographics\">\n\n";
;
}
output += "\n\n    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "v")),"viewStates")),"profileShowErrors") && runtime.memberLookup(((lineno = 12, colno = 54, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Profile")),"get"), "Profile[\"get\"]", context, ["errors"]))),"location") == "demographics-form") {
output += "\n\n    <form novalidate class=\"js-account-profile-demographics-form js-account-errors\" name=\"demographics-form\">\n\n    ";
;
}
else {
output += "\n\n    <form novalidate class=\"js-account-profile-demographics-form\" name=\"demographics-form\">\n\n    ";
;
}
output += "\n\n        ";
env.getTemplate("./demographics-edit-birthday.j2", false, "account/templates/partials/demographics-edit.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n\n        ";
env.getTemplate("./demographics-edit-gender.j2", false, "account/templates/partials/demographics-edit.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n        ";
env.getTemplate("./demographics-edit-student.j2", false, "account/templates/partials/demographics-edit.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n    </form>\n\n</section>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/demographics-edit.j2"] , dependencies)